import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type { GroupPermission, GroupDTO } from './useGetGroups';

export interface UpdateGroupPayload {
	groupId: string;
	name: string;
	permissions: GroupPermission[];
}

export const useUpdateGroup = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ groupId, ...payload }: UpdateGroupPayload) => {
			try {
				const { data } = await api.put<GroupDTO>(`/management/group/update/${groupId}`, payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar grupo');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['groups'] });
			queryClient.invalidateQueries({ queryKey: ['group'] });
		},
	});
};
